import { useTheme } from '@emotion/react';
import { Box, Divider, Grid, useMediaQuery } from '@mui/material';
import avatar3 from 'assets/avatar-3.png';
import AppAvatar from 'components/avatars/AppAvatar';
import FlexBox from 'components/flexbox/FlexBox';
import { H6, Tiny } from 'components/Typography';
import React, { useState } from 'react';
import FlexRowAlign from './flexbox/FlexRowAlign';

import { ThumbsUp } from 'lucide-react';
import { MessageCircle } from 'react-feather';

export default function CommentNew({ item, type }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isLiked, setIsLiked] = useState(false);

  const handleReplyClick = () => {
    // Create and dispatch a custom event
    const event = new CustomEvent('add-reply-tag');
    document.dispatchEvent(event);

    // Add smooth scrolling after a short delay to allow the comment box to render
    setTimeout(() => {
      const commentBox = document.querySelector(
        '.comment-create-box-container'
      );
      if (commentBox) {
        commentBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  };

  const handleEditClick = () => {
    // Create and dispatch a custom event with comment data
    const event = new CustomEvent('edit-comment', {
      detail: {
        commentId: item.id || Date.now(), // Use item.id if available, fallback to timestamp
        commentText: item.comment,
        writer: item.writer,
        date: item.date,
      },
    });
    document.dispatchEvent(event);

    // Add smooth scrolling to comment box
    setTimeout(() => {
      const commentBox = document.querySelector(
        '.comment-create-box-container'
      );
      if (commentBox) {
        commentBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  };

  const iconData = [
    {
      Icon: ThumbsUp,
      title: '좋아요',
      color: isLiked ? 'darkBlue' : 'grey900',
      value: '28',
      onClick: () => setIsLiked(!isLiked),
    },
    { Icon: MessageCircle, title: '댓글', color: 'grey900', value: '9' },
  ];

  return (
    <Grid
      container
      direction="row"
      justifyContent={'center'}
      alignItems={'center'}
      sx={{
        padding: '1rem 1rem',
        backgroundColor: '#ffffff',
        paddingLeft: type === 'reply' ? '3rem' : '1rem',
      }}
    >
      <Grid
        container
        direction={'row'}
        py={isMobile ? 0 : 1}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          flexWrap: isMobile ? 'inherit' : 'nowrap',
        }}
      >
        <Grid
          gap={1}
          item
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
          }}
        >
          <FlexBox
            gap={1.2}
            alignItems="center"
            sx={{ justifyContent: 'flex-start' }}
          >
            <AppAvatar
              alt={'avatar'}
              src={avatar3}
              style={{ width: '34px', height: '34px' }}
            />
            <FlexBox flexDirection="row">
              <H6 sx={{ fontSize: isMobile ? 13 : 'inherit' }}>
                {item.writer}
              </H6>
              <Tiny mb={0.5} ml={1}>
                {item.date}
              </Tiny>
            </FlexBox>
          </FlexBox>

          <H6
            style={{
              marginLeft: 0,
              paddingLeft: 0,
              textAlign: 'left',
              fontSize: isMobile ? 13 : 'inherit',
            }}
          >
            {type === 'reply' && (
              <Box
                component="span"
                sx={{ color: theme.palette.primary.darkBlue, mr: 1 }}
              >
                @디자이너 채은
              </Box>
            )}
            {item.comment}
          </H6>

          <FlexRowAlign
            sx={{
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: isMobile ? 1.5 : 2.5,
            }}
          >
            {iconData.map(({ Icon, title, color, value, onClick }, index) => (
              <React.Fragment key={index}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={onClick}
                >
                  <Icon
                    size={isMobile ? 14 : 16}
                    color={theme.palette.primary[color]}
                    style={{ marginRight: '4px' }}
                  />
                  <H6
                    sx={{
                      fontSize: isMobile ? 12 : 14,
                      color: theme.palette.primary[color],
                      fontWeight: 500,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {title} {value}
                  </H6>
                </Box>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    height: '14px',
                    alignSelf: 'center',
                    borderColor: theme.palette.primary.grey900,
                  }}
                />
              </React.Fragment>
            ))}
            <H6
              onClick={handleEditClick}
              sx={{
                fontSize: isMobile ? 12 : 14,
                color: theme.palette.primary.grey900,
                fontWeight: 500,
                whiteSpace: 'nowrap',
                cursor: 'pointer',
              }}
            >
              수정
            </H6>
            <Divider
              orientation="vertical"
              flexItem
              sx={{
                height: '14px',
                alignSelf: 'center',
                borderColor: theme.palette.primary.grey900,
              }}
            />
            <H6
              onClick={handleReplyClick}
              sx={{
                fontSize: isMobile ? 12 : 14,
                color: theme.palette.primary.grey900,
                fontWeight: 500,
                whiteSpace: 'nowrap',
                cursor: 'pointer',
              }}
            >
              답글 달기
            </H6>
          </FlexRowAlign>
        </Grid>
      </Grid>
    </Grid>
  );
}
